import React, { useRef, useEffect } from 'react';
import './SidePanel.scss';
import { createPortal } from 'react-dom';

interface SidePanelProps {
  open: boolean;
  onClose: () => void;
  header: React.ReactNode;
  children: React.ReactNode;
  width?: number | string;
  footer?: boolean;
  handleResetClick?: () => void;
  handleApply?: () => void;
  applyDisabled?: boolean;
}

const SidePanel: React.FC<SidePanelProps> = ({
  open,
  onClose,
  header,
  children,
  width = 350,
  footer,
  handleResetClick,
  handleApply,
  applyDisabled,
}) => {
  const panelRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const handleClickOutside = (event: MouseEvent) => {
      if (panelRef.current && !panelRef.current.contains(event.target as Node)) {
        onClose();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open, onClose]);

  if (!open) return null;

  return createPortal(
    <div>
      <div onClick={onClose} />
      <div className='sidepeep-panel main-container-panel main-container__wrapper' ref={panelRef} style={{ width }}>
        <header className='header side-panel-header-container'>
          <div className='header__logo-container'>
            <div className='header__logo-icon'>
              <div className='header__logo-icon-inner cursor-pointer' onClick={onClose} />
            </div>
            <div className='header__logo-text side-panel-header'>{header}</div>
          </div>
        </header>
        <main className='main-content' style={{ flex: 1, overflowY: 'auto' }}>
          {children}
        </main>
        {footer && (
          <footer className='footer ' style={{ zIndex: 99 }}>
            <div className='footer__container' style={{ justifyContent: 'flex-end', alignItems: 'center', gap: '8px' }}>
              <button
                analytics-id='column-selector-reset-btn'
                className='footer__reset-button'
                onClick={handleResetClick}
                style={{ minWidth: 100 }}
              >
                <span className='footer__apply-button-text'>Reset all</span>
              </button>
              <button
                analytics-id='column-selector-apply-btn'
                className={`footer__apply-button ${applyDisabled ? 'footer__apply-button-disabled' : ''}`}
                onClick={handleApply}
                style={{ minWidth: 100 }}
                disabled={applyDisabled}
              >
                <span className='footer__apply-button-text'>Apply</span>
              </button>
            </div>
          </footer>
        )}
      </div>
    </div>,
    document.querySelector('.outlet-container') || document.body,
  );
};

export default SidePanel;
